import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js'
import VueElementLoading from 'vue-element-loading'
import { BasicSelect } from 'vue-search-select'
import jsPDF from 'jspdf'
import JsBarcode from 'jsbarcode'

export default {
  name: 'barcode',
  components: {
    BasicSelect,
    VueElementLoading,
  },
  data() {
    return {
      hubid: '',
      hubname: '',
      binno: '',
      bayno: '',
      layout:'',
      layoutno:'',
      isLoadingSearch: false,
      binDetails: [],
      binItem: {},
      layoutDetails: [],
      layoutItem: {},
      bayDetails: [],
      bayItem: {},
      selected: '',
      baynoResetKey: 0,
      binnoResetKey: 0,
      layoutResetKey: 0,
      showValidationErrors: false,
      activelayout: false,
      baybarcode :''
    }
  },

  computed: {
    options() {
      const baseOptions = [
        { text: 'Bay Search', value: 'bay' },
        { text: 'Bin Search', value: 'bin' }
      ];
      
      if (this.activelayout) {
        baseOptions.push({ text: 'Layout Area', value: 'layout' });
      }
      
      return baseOptions;
    },
    isPrintAllBarcodeDisabled() {
      if (!this.activelayout) {
        return (
          (this.selected === 'bay' && this.bayno) ||
          (this.selected === 'bin' && this.binno) ||
          this.selected === ''
        );
      } else {
        return (
          this.selected === '' ||
          (this.selected === 'bay' && (!this.layoutno && !this.bayno)) ||
          (this.selected === 'bin' && (!this.layoutno && !this.binno))
        );
      }
    }
  },

  mounted() {
    const userdetailEncrypt = window.localStorage.getItem('userdetail')
    const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
    const plaintext = bytes.toString(CryptoJS.enc.Utf8)
    const userdetail = JSON.parse(plaintext)
    this.hubid = userdetail[0].HubId[0]
    this.getHubName(this.hubid)
    this.getActiveLayouts();
  },

  methods: {
    getHubName(hubid) {
      this.input = { hubids: [hubid] }
      axios.post(`${apiUrl.api_url_hubops}expose/hubservicecenter/hubarray/get`, this.input, {
        headers: { authorization: "authkey xB84JJ89Hd25" }
      }).then(result => {
        if (result.data.ResultCode === 100) {
          this.hubname = result.data.ResponseData[0].HubName
        }
      }).catch(console.error)
    },
    getActiveLayouts() {
      axios({
          method: 'GET',
          url: apiUrl.api_url_hubops +'getAllActiveLayoutsForHub?currentHubId=' + this.hubid + '&isActive='+ true + '&isConfigActive='+ true,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
			      this.activelayout = true;
            this.layoutDetails = result.data.ResponseData.map( layout=> ({
            text: layout.layoutnumber,
            value: layout.layoutnumber
          }));
          } else {
			      this.activelayout = false;
          }
        }, error => {
          console.error(error)
        })
    },

    onSearchTypeChange() {
      this.resetSelectionOnly()
      this.getActiveLayouts();
      if (!this.activelayout) {
        if (this.selected === 'bay') {
        this.getBayList()
      } else {
        this.getBinList()
      }
      }
    },

    getBayList(layoutbayno) {
      this.bayDetails = []
      this.isLoadingSearch = true
      let api = (this.activelayout)? `getAllBayList?currentHubId=${this.hubid}&currentHubName=${this.hubname}&layoutNumber=${layoutbayno}` :`getAllBayList?currentHubId=${this.hubid}&currentHubName=${this.hubname}`;
      axios.get(`${apiUrl.api_url_hubops}`+api, {
        headers: { Authorization: "authkey xB84JJ89Hd25" }
      }).then(result => {
        if (result.data.ResultCode === 100) {
          this.bayDetails = (this.activelayout) ? result.data.ResponseData.map(bay => ({
            text: bay.baynumberwithlayout,
            value: bay.baynumberwithlayout,
            barcode:bay.baybarcodelabel
          })):result.data.ResponseData.map(bay => ({
            text: bay.baynumber,
            value: bay.baynumber,
            barcode:bay.baynumber
          }));

        }
      }).finally(() => {
        this.isLoadingSearch = false
      })
    },

    getBinList(layoutbinno) {
      this.binDetails = []
      this.isLoadingSearch = true
      let api = (this.activelayout)? `getAllBinListForSorter?currentHubId=${this.hubid}&currentHubName=${this.hubname}&layoutNumber=${layoutbinno}` :`getAllBinListForSorter?currentHubId=${this.hubid}&currentHubName=${this.hubname}`;
      axios.get(`${apiUrl.api_url_hubops}` + api, {
        headers: { Authorization: "authkey xB84JJ89Hd25" }
      }).then(result => {
        if (result.data.ResultCode === 100) {
         this.binDetails = result.data.ResponseData.map(bin => ({
            text: bin.bin_barcode,
            value: bin.bin_barcode
          }));
        }
      }).finally(() => {
        this.isLoadingSearch = false
      })
    },

    selectedBin(binItem) {
      this.binItem = binItem
      this.binno = binItem.value
    },

    selectedBay(bayItem) {
      this.bayItem = bayItem
      this.bayno = bayItem.value
      this.baybarcode = (this.activelayout) ? bayItem.barcode :''
    },

    selectedLayout(layoutItem) {
      this.layoutItem = layoutItem
      this.layoutno = layoutItem.value
      if (this.activelayout) {
        if (this.selected === 'bay') {
        this.getBayList(this.layoutno)
      } else if (this.selected === 'bin'){
        this.getBinList(this.layoutno)
      }
      }
    },

   onSubmit(actionType) {
      

      // If no search type is selected
      if (!this.selected) {
        this.$alertify.error("Please select a search type.");
        return;
      }

     
      if (actionType === 1) {
        this.showValidationErrors = false;
        this.bulkAction(actionType);
        return;
      }

      this.showValidationErrors = true;

      if (
        (this.selected === 'bay' && !this.bayno) ||
        (this.selected === 'bin' && !this.binno) ||
        (this.selected === 'layout' && !this.layoutno)
      ) {
        
        return;
      }

      this.bulkAction(actionType);
    },

    async bulkAction(elem) {
      this.isLoadingSearch = true;
      const doc = new jsPDF('p', 'pt', 'a4');
      doc.setFont('helvetica', 'bold');
      doc.setLineWidth(0.5);
    
      let o = 0, e = 0;
      let listToPrint = [];
    
      if (elem === 0) {
        // Single barcode
        let value, label;
        if (this.selected === 'bay') {
          value = this.bayno;
          label = (this.activelayout) ? `${this.baybarcode}`:`${this.hubname} - ${value}`;
        } else if (this.selected === 'bin') {
          value = this.binno;
          label = value;
        } else if (this.selected === 'layout') {
          value = this.layoutno;
          label = `${value} - ${this.hubname}`;
        }
        const barcode = await this.textToBase64Barcode(value);
        doc.rect(32, 65, 216, 200);
        doc.addImage(barcode, 'JPEG', 55, 95, 168, 70);
        doc.setFontSize(14);
        doc.text(label, 140, 180, { align: 'center' });
      } else {
        if (this.selected === 'bin') {
          listToPrint = this.binDetails;
        } else if (this.selected === 'bay') {
          listToPrint = this.bayDetails;
        } else if (this.selected === 'layout') {
          listToPrint = this.layoutDetails;
        }
    
        for (let i = 0; i < listToPrint.length; i++) {
          const value = listToPrint[i].value;
          const barcodelabel = listToPrint[i].barcode;
          let label;
          if (this.selected === 'bay') {
            label = (this.activelayout) ? `${barcodelabel}`:`${this.hubname} - ${value}`;
          } else if (this.selected === 'bin') {
            label = value;
          } else if (this.selected === 'layout') {
            label = `${value} - ${this.hubname}`;
          }
          const barcode = await this.textToBase64Barcode(value);
    
          const x = i % 2 === 0 ? 32 : 334;
          const y = i % 2 === 0 ? (65 + o * 260) : (65 + e * 260);
    
          doc.rect(x, y, 216, 200);
          doc.addImage(barcode, 'JPEG', x + 23, y + 30, 168, 70);
          doc.setFontSize(14);
          doc.text(label, x + 108, y + 120 + 15, { align: 'center' });
    
          if (i % 2 === 0) o++;
          else e++;
    
          if (o === 3 && e === 3) {
            doc.addPage();
            o = 0;
            e = 0;
          }
        }
      }
    
      doc.save('sticker.pdf');
      this.isLoadingSearch = false;
    },

    async textToBase64Barcode(text) {
      const canvas = document.createElement('canvas')
      JsBarcode(canvas, text, {
        format: 'CODE39',
        displayValue: false, 
        height: 150,
        margin: 10
      })
      return canvas.toDataURL('image/png')
    },

    resetSelectionOnly() {
      this.binno = ''
      this.bayno = ''
      this.layoutno = ''
      this.binItem = {}
      this.bayItem = {}
      this.layoutItem = {}
      this.binDetails = []
      this.bayDetails = []
      this.layoutDetails = []
      this.baybarcode=''
      this.showValidationErrors = false;
      
      this.baynoResetKey++
      this.binnoResetKey++
      this.layoutResetKey++
    },

    resetForm() {
      this.selected = ''
      this.resetSelectionOnly()
      this.showValidationErrors = false
      this.isLoadingSearch = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/SorterPrintSticker/SorterPrintSticker.js